import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-trash-can-lined",
  "use": "rt-base-trash-can-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-trash-can-lined\"><path d=\"M424 822c4.4 0 8-3.6 8-8V378c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v436c0 4.4 3.6 8 8 8h48zM656 822c4.4 0 8-3.6 8-8V378c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v436c0 4.4 3.6 8 8 8h48z\" /><path d=\"M856 370h-48c-4.4 0-8 3.6-8 8v512c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V378c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v552c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V378c0-4.4-3.6-8-8-8zM904 199H668.8C654 126 589.4 71 512 71s-142 55-156.8 128H120c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h290.8c5.1 0 9-4.8 7.8-9.8-2-8.5-2.9-17.4-2.5-26.6 2.2-48 44.3-89.8 92.3-91.5 54.6-2 99.6 41.8 99.6 95.9 0 7.6-0.9 15-2.6 22.2-1.2 5 2.6 9.8 7.8 9.8H904c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/trash-can-lined.svg
// module id = 1798
// module chunks = 137